import React from 'react';
interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}
export function Sparkline({
  data,
  width = 80,
  height = 24,
  color = '#0187c3',
  className = ''
}: SparklineProps) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const points = data.map((value, index) => {
    const x = index / (data.length - 1) * width;
    const y = height - (value - min) / range * height;
    return `${x},${y}`;
  }).join(' ');
  return <svg width={width} height={height} className={className} viewBox={`0 0 ${width} ${height}`} data-id="element-117">
      <polyline fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" points={points} data-id="element-118" />
    </svg>;
}